import { Switch as MuiSwitch, SwitchProps as MuiSwitchProps } from "@mui/material";

export const Switch: React.FC<MuiSwitchProps> = (props) => {
  return <MuiSwitch {...props} />;
};

export default Switch;
